<ng-container>
  @if (showHeaderFooter$ | async) {
    <dl-header></dl-header>
  }
  <router-outlet></router-outlet>
  @if (showHeaderFooter$ | async) {
    <dl-footer></dl-footer>
  }
</ng-container>
